export default "__VITE_ASSET__60c6ec13__"